module.exports = __WEBPACK_EXTERNAL_MODULE_56__;


//////////////////
// WEBPACK FOOTER
// external "element-ui/lib/loading"
// module id = 56
// module chunks = 0 1 2